import { render, staticRenderFns } from "./WeightChart.vue?vue&type=template&id=8b7fbca0&"
import script from "./WeightChart.vue?vue&type=script&lang=js&"
export * from "./WeightChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/nc21docker/apps/health/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b7fbca0')) {
      api.createRecord('8b7fbca0', component.options)
    } else {
      api.reload('8b7fbca0', component.options)
    }
    module.hot.accept("./WeightChart.vue?vue&type=template&id=8b7fbca0&", function () {
      api.rerender('8b7fbca0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/weight/WeightChart.vue"
export default component.exports